import { render, staticRenderFns } from "./main-information.vue?vue&type=template&id=4412dc4c&scoped=true"
import script from "./main-information.vue?vue&type=script&lang=js"
export * from "./main-information.vue?vue&type=script&lang=js"
import style0 from "./main-information.vue?vue&type=style&index=0&id=4412dc4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412dc4c",
  null
  
)

export default component.exports